/*
Version 0.140

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2019.

!Changelog

2020
	17-02-2020
	- [BORN] This class is born. Hooray!

!Usage

	-
	
!Wishlist

	none
	
*/
  
var specific_scroller = {};

(function(){
	 
	// PRELOAD & DOCUMENT READY  *****************************************************************
	// PRELOAD & DOCUMENT READY *****************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************

	this.onready = function() {
			
		/*
		Click
		*/
		$(document).on('click','.js-scroll2',function() {

			var _id = $(this).data('scroll2');

			specific_scroller.scroll2(_id);

		});

		var _scroll_var = '';
		if(url[3]) {
			_scroll_var = url[3];
		} else {
			_scroll_var = url[2];
		}

		/*
		Scroll directly on load
		*/
		switch(_scroll_var) {

			default:
				specific_scroller.scroll2('homepage');
			break;

			case 'informatie':
			case 'information':
				specific_scroller.scroll2('information');
			break;

				case 'why-do-you-choose-me':
				case 'waarom-kies-je-voor-mij':
					specific_scroller.scroll2('why');
				break;

				case 'what-can-you-expect':
				case 'wat-kunt-u-verwachten':
					specific_scroller.scroll2('expect');
				break;

			case 'contact':
				specific_scroller.scroll2('contact');
			break;

		}

	};
	
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	
	this.scroll2 = function(_id) {

		var _marge = 0;
		if($(window).width() > 500) {
			_marge = 0;
		}

		$('html,body').stop().animate({
			scrollTop: $('.js-scroll2-' + _id).offset().top - _marge
		}, 500);

	};

}).apply(specific_scroller); 